export default __webpack_public_path__ + "cca37750e1136f9aca99bd73a492552a.woff";